import React from 'react';
import RichEditor from '../common/RichEditor';


export default function DescForm(props: any) {
  const action = props.action
  const handleChange = props.handleChange
  const ticketUpdateForm = props.ticketUpdateForm

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <div className='tkt-form-section-title'>
          <p>Descripción</p>
        </div>

        <div className='tkt-form-section-item__desc'>
          <RichEditor
            disabled={action === 'view'}
            name='description'
            value={ticketUpdateForm.description}
            handleChange={handleChange}
          />
        </div>

      </div>

    </React.Fragment>
  );
}
